import { render, staticRenderFns } from "./ShippingCalculationModal.vue?vue&type=template&id=06e64229&scoped=true"
import script from "./ShippingCalculationModal.vue?vue&type=script&lang=js"
export * from "./ShippingCalculationModal.vue?vue&type=script&lang=js"
import style0 from "./ShippingCalculationModal.vue?vue&type=style&index=0&id=06e64229&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e64229",
  null
  
)

export default component.exports